function initDistanceUnitToggle() {
	
	// get preference from cookie - default to miles
	const match = document.cookie.match(/(?:^|;\s*)units=(miles|km)(?:;|$)/);
	let units = match ? match[1] : 'miles';
	
	// set body data attribute
	document.body.dataset.distanceUnits = units;
	
	// update spans if necessary
	if(units === 'km') changeDistanceUnits();

	const checkbox = document.querySelector('input#distancetoggle');
	if(checkbox) {
		
		// set toggle initial state
		checkbox.checked = units === 'km';
		
		checkbox.addEventListener('change', ()=>{
			
			units = !checkbox.checked ? 'miles' : 'km';
			document.body.dataset.distanceUnits = units;
			
			changeDistanceUnits();
			
			document.cookie = 'units='+units+'; max-age=31536000; path=/; SameSite=Lax';
			
			// change scale on any maps
			scaleControls.forEach(scaleControl => {
				let new_unit = units === 'km' ? 'metric' : 'imperial';
				scaleControl.setUnit(new_unit);
			});
			
			
		});
	}

}
initDistanceUnitToggle();


// change distance span units
function changeDistanceUnits() {
	const units = document.body.dataset.distanceUnits ?? 'miles';
	const spans = document.querySelectorAll('span.distance');
	spans.forEach(span => {
		const content = span.dataset[units];
		if(content) span.textContent = content;
	});
}

  